import mqtt from 'mqtt';
import { wrap, middlewares } from 'mqtt-sub-router';
const setup = (username, password, opts, routersMap, mqttMiddlewares, extraDependencies, callbacks = {}, onceCallbacks = {}) => {
    const { onConnect, onDisconnect, onOffline, onClose, onEnd, onError, onReconnect } = callbacks;
    const { onConnect: onceConnect, onOffline: onceOffline, onError: onceError } = onceCallbacks;
    const baseMqttClient = mqtt
        .connect(`${opts.protocol}://${opts.host}:${opts.port}/${opts.path}`, {
        username,
        password,
        protocolVersion: opts.protocolVersion,
        keepalive: opts.keepalive,
        will: opts.will
    })
        // bind one-time event listeners
        .once('connect', (connack) => onceConnect ? onceConnect(connack, extraDependencies) : null)
        .once('error', (error) => (onceError ? onceError(error, extraDependencies) : null))
        .once('offline', () => (onceOffline ? onceOffline(extraDependencies) : null))
        // bind long-lived event listeners
        .on('connect', (connack) => (onConnect ? onConnect(connack, extraDependencies) : null))
        .on('disconnect', (packet) => onDisconnect ? onDisconnect(packet, extraDependencies) : null)
        .on('reconnect', () => {
        onReconnect ? onReconnect(extraDependencies) : null;
    })
        .on('offline', () => (onOffline ? onOffline(extraDependencies) : null))
        .on('close', () => (onClose ? onClose(extraDependencies) : null))
        .on('error', (error) => (onError ? onError(error, extraDependencies) : null));
    /**
     * Middleware that attempts to parse incoming messages as JSON.
     * If the message is not parsable, it is returned as it it.
     *
     * The final structure of message that is passed to the next handler is of the form
     *
     * ```js
     * 	{
     * 		data: JSON.parse(originalMessage) | originalMessage
     * 	}
     *	```
     */
    const jsonMQTTMiddleware = next => args => {
        let jsonParsedMessage;
        try {
            jsonParsedMessage = JSON.parse(args.message);
        }
        catch (error) {
            // pass on the message as it is
            jsonParsedMessage = args.message;
        }
        // call the next middleware in the chain
        return next(Object.assign(Object.assign({}, args), { message: jsonParsedMessage }));
    };
    /** Mqtt middleware that injects the extraDependencies into args in the mqtt message
     * handler functions */
    const diMQTTMiddleware = middlewares.dependencyInjectionMiddlewareBuilder(extraDependencies);
    const wrappedMqttClient = wrap(baseMqttClient, [diMQTTMiddleware, jsonMQTTMiddleware, ...mqttMiddlewares]);
    // bind the routers to wrappedMqttClient
    Object.entries(routersMap).forEach(([topic, router]) => {
        wrappedMqttClient.listen(topic, router);
    });
    return wrappedMqttClient;
};
export default setup;
